import React from 'react';
import PropTypes from 'prop-types';
import NavigationContext from './Context';

class NavigationDataTransformProvider extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    transformNavigationData = (tourData, navigationData) => {
        if (!tourData || !navigationData) {
            return null;
        }

        let transformedNavigationData = {
            ...navigationData,
        };

        let groupIdToSphereIds = {};
        for (let group of tourData.groups) {
            groupIdToSphereIds[group.groupId] = group.sphereIds;
        }

        let groupIdToUnlabeledSpheres = {};
        for (let group of transformedNavigationData.groups) {
            let sphereIdsForGroup = groupIdToSphereIds[group.id]
                ? groupIdToSphereIds[group.id]
                : [];
            let unlabeledSpheresForGroup = [...sphereIdsForGroup];

            for (let space of group.spaces) {
                if (space.spheres) {
                    for (let sphere of space.spheres) {
                        if (unlabeledSpheresForGroup.includes(sphere.id)) {
                            unlabeledSpheresForGroup.splice(
                                unlabeledSpheresForGroup.indexOf(sphere.id),
                                1
                            );
                        }
                    }
                }
            }
            groupIdToUnlabeledSpheres[group.id] = unlabeledSpheresForGroup;
        }

        let transformedGroups = [];
        for (let group of transformedNavigationData.groups) {
            transformedGroups.push({
                ...group,
                unlabeledSpheres: groupIdToUnlabeledSpheres[group.id],
            });
        }

        transformedNavigationData.groups = transformedGroups;
        return transformedNavigationData;
    };

    render() {
        return (
            <NavigationContext.Provider
                value={this.transformNavigationData(this.props.tourData, this.props.navigationData)}
            >
                {this.props.children}
            </NavigationContext.Provider>
        );
    }
}

NavigationDataTransformProvider.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    tourData: PropTypes.object.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    navigationData: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
};

export default NavigationDataTransformProvider;
